import { render } from "./IncomeSourceChart.vue?vue&type=template&id=a30714e6&ts=true"
import script from "./IncomeSourceChart.vue?vue&type=script&lang=ts"
export * from "./IncomeSourceChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__